import React from "react";
import { OperatingSystems } from "../../utils/vendor";
import SaveHyperOnIos from "./SaveHyperOnIos/SaveHyperOnIos";
import { GenericModalProps } from "../../utils/constants/generic-types";
import SaveHyperOnAndroid from "./SaveHyperOnAndroid/SaveHyperOnAndroid";
import { checkOs } from "../../utils/helpers";

export default function PwaInstallationDialog({
  isOpen,
  onClose,
}: GenericModalProps) {
  if (checkOs() === OperatingSystems.Ios) {
    return <SaveHyperOnIos isOpen={isOpen} onClose={onClose} />;
  }
  return <SaveHyperOnAndroid isOpen={isOpen} onClose={onClose} />;
}
